import React, { useEffect, useState } from 'react';
import '../styles/LocalDateTime.css'; // External CSS

// Helper function to get user's full timezone (e.g., "America/Edmonton")
export const getUserTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const formatDate = (date) => {
    const options = { month: 'long' };
    const month = new Intl.DateTimeFormat('en-US', options).format(date);
    const day = date.getDate();
    const suffix = getDaySuffix(day);
    const year = date.getFullYear();

    const time = date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true,
    });

    const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const tzShort = date.toLocaleTimeString('en-us', {
        timeZoneName: 'short'
    }).split(' ').pop();

    return `Today's Date: ${month}, ${day}${suffix} ${year} ${time} (${tzShort} - ${timeZoneName})`;
};

const getDaySuffix = (day) => {
    if (day >= 11 && day <= 13) return 'th';
    switch (day % 10) {
        case 1: return 'st';
        case 2: return 'nd';
        case 3: return 'rd';
        default: return 'th';
    }
};

const LocalDateTime = () => {
    const [currentDate, setCurrentDate] = useState(new Date());

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentDate(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    return (
        <p className="local-date-time">{formatDate(currentDate)}</p>
    );
};

export default LocalDateTime;
